// extracted by mini-css-extract-plugin
export var cardLayout = "_79-1";
export var paginationContainer = "_79-0";